// German-formatted helpers for money, dates and percentages.
const eur = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const num = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoney(value, withSign = false) {
  const n = Number(value || 0);
  if (withSign && n > 0) return `+${eur.format(n)}`;
  return eur.format(n);
}

export function formatNumber(value) {
  return num.format(Number(value || 0));
}

export function formatPercent(value) {
  const n = Number(value || 0);
  return `${num.format(n)} %`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatPeriod(periodMonth, label) {
  if (label) return label;
  if (!periodMonth) return "—";
  const [y, m] = periodMonth.split("-");
  if (!y || !m) return periodMonth;
  const date = new Date(Number(y), Number(m) - 1, 1);
  return date.toLocaleDateString("de-DE", { month: "long", year: "numeric" });
}
